<template>
    <div class="np-detail-section">
        <div class="np-detail-section__title np-detail-section__title--no-border"><span>4. Prices</span>
            <button type="button" class="btn btn--green" @click="isOpenSeasons = true">
            <svg width="1em" height="1em" class="icon icon-list ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-list"></use>
            </svg><span>Seasons</span>
            </button>
        </div>
        <div class="np-detail-season" v-if="seasons.find(item => item.active)">
            <div class="np-detail-season__header">
            <div class="np-detail-season__filters">
                <div class="np-detail-season__filters__side">
                <div class="form-control-group"><span class="form-control-label">Choose Season</span>
                    <div :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.seasons }]" @click="changeSelects('seasons');">
                        <div class="select-trigger"><span class="select-trigger__name"><b>{{seasons.find(item => item.active).name}}</b> <i>{{seasons.find(item => item.active).dateFrom}} - {{seasons.find(item => item.active).dateTo}}</i></span><span class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                            <div class="select-body">
                                <div class="select-inner">
                                    <div
                                        v-for="item in seasons"
                                        :key="item.id"
                                        :class="['select-option', {'is-selected' : item.id === seasons.find(item => item.active).id}]"
                                        @click="seasons = seasons.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                        ><span class="select-option__name"><b>{{item.name}}</b> <i>{{item.dateFrom}} - {{item.dateTo}}</i></span></div>
                                </div>
                            </div>
                    </div>
                    </div><span title="Sorry, this season is not available because something is wrong" class="form-control-group__error">Sorry, this season is not available because something is wrong</span>
                <button type="button" class="btn btn-copy btn--green btn--shadowed" @click="copySeason = true">
                    <svg width="1em" height="1em" class="icon icon-copy ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                    </svg><span>Copy from another season</span>
                </button>
                <button type="button" class="btn btn-copy btn--green btn--shadowed" @click="copySeasonPark = true">
                    <svg width="1em" height="1em" class="icon icon-copy ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                    </svg><span>Copy from another park</span>
                </button>
                </div>
                <!-- <div class="np-detail-season__filters__side">
                    <button type="button" class="btn btn-save btn--green btn--sm" @click="createParkPricesHandler"><span>Save</span></button>
                </div> -->
                </div>
            </div>
            </div>
            <div class="np-detail-season__inner">
            <div class="season-box-wrap">
                <div class="season-box-group-title">
                <svg width="1em" height="1em" class="icon icon-car ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-car"></use>
                </svg><span>Car & Driver Fees</span>
                </div>
                <div class="season-box">
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Name</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>Price</span></div>
                    </div>
                    <SeasonBox :title="'Driver Fee'" :placeholder="'4 500 000'" :currency="data.driverFreeCur" :value="data.driverFree" @changeValue="changeValue" :name="'driverFree'" @changeCurrency="changeCurrency" />
                </div>
                </div>
                <div class="season-box">
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Name</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>Price</span></div>
                    </div>
                    <SeasonBox :title="'2001 - 3000kg'" :placeholder="'4 500 000'" :currency="data.kg2001Cur" :value="data.kg2001" @changeValue="changeValue" :name="'kg2001'" @changeCurrency="changeCurrency" />
                </div>
                </div>

                 <div class="season-box season-box_only-ngorongoro">
                    <label  class="form-control-checkbox" @click.prevent.stop="crater = !crater">
                        <input type="checkbox" :checked="crater" ><span class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg></span><span class="form-control-checkbox__name">Crater Fees (only for Ngorongoro)</span>
                    </label>
                    <div class="season-box__table season-box__table_only-ngorongoro" :style="{opacity: crater ? '1' : '0'}" id="example8">
                         <SeasonBox :title="'Foreing'" :placeholder="'4 500 000'" :currency="data.craterForCur" :value="data.craterFor" @changeValue="changeValue" :name="'craterFor'" @changeCurrency="changeCurrency" />

                         <SeasonBox :title="'East African'" :placeholder="'4 500 000'" :currency="data.craterEastCur" :value="data.craterEast" @changeValue="changeValue" :name="'craterEast'" @changeCurrency="changeCurrency" />

                    </div>
                    </div>
            </div>
            <div class="season-box-wrap">
                <div class="season-box">
                <div class="season-box__title">
                    <svg width="1em" height="1em" class="icon icon-user ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-user"></use>
                    </svg><span>Park Fees EA</span>
                </div>
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Age</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>Price</span></div>
                    </div>
                    <SeasonBox :title="'Adult EA'" :placeholder="'1000'" :currency="data.adultSACur" :value="data.adultSA" @changeValue="changeValue" :name="'adultSA'" @changeCurrency="changeCurrency" />
                    <SeasonBox :title="'Teenager EA'" :placeholder="'1000'" :currency="data.teenSACur" :value="data.teenSA" @changeValue="changeValue" :name="'teenSA'" @changeCurrency="changeCurrency" />
                    <SeasonBox :title="'Child EA'" :placeholder="'1000'" :currency="data.childSACur" :value="data.childSA" @changeValue="changeValue" :name="'childSA'" @changeCurrency="changeCurrency" />
                </div>
                </div>
                <div class="season-box">
                <div class="season-box__title">
                    <svg width="1em" height="1em" class="icon icon-user ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-user"></use>
                    </svg><span>Park Fees Foreign</span>
                </div>
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Age</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>Price</span></div>
                    </div>
                    <SeasonBox :title="'Adult Foreign'" :placeholder="'1000'" :currency="data.adultForCur" :value="data.adultFor" @changeValue="changeValue" :name="'adultFor'" @changeCurrency="changeCurrency" />
                    <SeasonBox :title="'Teenager Foreign'" :placeholder="'1000'" :currency="data.teenForCur" :value="data.teenFor" @changeValue="changeValue" :name="'teenFor'" @changeCurrency="changeCurrency" />
                    <SeasonBox :title="'Child Foreign'" :placeholder="'1000'" :currency="data.childForCur" :value="data.childFor" @changeValue="changeValue" :name="'childFor'" @changeCurrency="changeCurrency" />
                </div>
                </div>
                <div class="season-box">
                <div class="season-box__title">
                    <svg width="1em" height="1em" class="icon icon-user ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-user"></use>
                    </svg><span>Park Fees Expat</span>
                </div>
                <div class="season-box__table">
                    <div class="season-box__table__header">
                    <div class="season-box__table__main"><span>Age</span></div>
                    <div class="season-box__table__currency"><span>Currency </span></div>
                    <div class="season-box__table__price"><span>Price</span></div>
                    </div>
                    <SeasonBox :title="'Adult Expat'" :placeholder="'1000'" :currency="data.adultExpCur" :value="data.adultExp" @changeValue="changeValue" :name="'adultExp'" @changeCurrency="changeCurrency" />
                    <SeasonBox :title="'Teenager Expat'" :placeholder="'1000'" :currency="data.teenExpCur" :value="data.teenExp" @changeValue="changeValue" :name="'teenExp'" @changeCurrency="changeCurrency" />
                    <SeasonBox :title="'Child Expat'" :placeholder="'1000'" :currency="data.childExpCur" :value="data.childExp" @changeValue="changeValue" :name="'childExp'" @changeCurrency="changeCurrency" />
                </div>
                </div>
            </div>
            </div>
            <Seasons @notLeavePopupHandler="data => $emit('notLeavePopupHandler', data)" @errored="$emit('errored')" @deleteModalHandler="data => $emit('deleteModalHandler', data)" :open="isOpenSeasons" @confirmed="$emit('confirmed')" :title="'Parks'" @close="closeSeasons" :type="'park'" :user="user"/>
            <div class="modal-wrapper" v-if="copySeason">
                <div class="modal-backdrop"></div>
                <div class="modal-inner">
                    <div class="edit-popup edit-popup--copy-season">
                        <div class="edit-popup__header">
                            <div class="edit-popup__title">
                            <div class="edit-popup__title__icon">
                                <svg width="1em" height="1em" class="icon icon-copy ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                </svg>
                            </div><span>Copy rates from another season</span>
                            </div>
                            <div class="edit-popup__close" @click="copySeason = false">
                            <svg width="1em" height="1em" class="icon icon-close ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                            </div>
                        </div>
                        <form action="javascript:void(0)" class="edit-popup__inner">
                            <div class="edit-popup__info">
                            <p>{{seasons.find(item => item.active).name}} <i>{{seasons.find(item => item.active).dateFrom}} - {{seasons.find(item => item.active).dateTo}}</i></p>
                            </div>
                            <div class="edit-popup__side-wrap">
                            <div class="edit-popup__side">
                                <div class="form-control-group"><span class="form-control-label">Choose Season</span>
                                <div :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.seasonsData }]" @click="changeSelects('seasonsData');">
                                    <div class="select-trigger"><span class="select-trigger__name"><b>{{seasonsData.find(item => item.active).name}}</b> <i>{{seasonsData.find(item => item.active).dateFrom}} - {{seasonsData.find(item => item.active).dateTo}}</i></span><span class="select-trigger__icon">
                                        <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                        </svg></span></div>
                                    <div class="select-body">
                                    <div class="select-inner">
                                        <div
                                            v-for="item in seasonsData"
                                            :key="item.id"
                                            :class="['select-option', {'is-selected' : item.id === seasonsData.find(item => item.active).id}]"
                                            @click="seasonsData = seasonsData.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                            ><span class="select-option__name"><b>{{item.name}}</b> <i>{{item.dateFrom}} - {{item.dateTo}}</i></span></div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <button type="submit" class="btn btn--green edit-popup__submit" @click.prevent="copyParkSeasonsFromSeason">
                                <svg width="1em" height="1em" class="icon icon-copy ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                </svg><span>Copy</span>
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-wrapper" v-if="copySeasonPark">
                <div class="modal-backdrop"></div>
                <div class="modal-inner">
                    <div class="edit-popup edit-popup--copy">
                        <div class="edit-popup__header">
                        <div class="edit-popup__title">
                            <div class="edit-popup__title__icon">
                            <svg width="1em" height="1em" class="icon icon-copy ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                            </svg>
                            </div><span>Copy rates from another season</span>
                        </div>
                        <div class="edit-popup__close" @click="copySeasonPark = false">
                            <svg width="1em" height="1em" class="icon icon-close ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                        </div>
                        </div>
                        <form action="javascript:void(0)" class="edit-popup__inner">
                        <div class="edit-popup__side">
                            <div class="form-control-group"><span class="form-control-label">Choose Park</span>
                            <div :class="['select-wrapper', { 'is-active' : selects.park }]" @click="changeSelects('park');">
                                <div class="select-trigger"><span class="select-trigger__name">{{parks.find(item => item.active) ? parks.find(item => item.active).nameForSystem : ''}}</span><span
                                    class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                                <div class="select-body">
                                <div class="select-inner js-scrollbar">
                                    <div
                                        v-for="item in parks"
                                        :key="item.id"
                                        :class="['select-option', {'is-selected' : item.id === parks.find(item => item.active).id}]"
                                        @click="parks = parks.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                        ><span class="select-option__name">{{item.nameForSystem}}</span></div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="edit-popup__side">
                            <div class="form-control-group"><span class="form-control-label">Choose Season</span>
                            <div :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.seasonsData }]" @click="changeSelects('seasonsData');">
                                <div class="select-trigger"><span class="select-trigger__name"><b>{{seasonsData.find(item => item.active).name}}</b> <i>{{seasonsData.find(item => item.active).dateFrom}} - {{seasonsData.find(item => item.active).dateTo}}</i></span><span class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                                <div class="select-body">
                                <div class="select-inner">
                                    <div
                                        v-for="item in seasonsData"
                                        :key="item.id"
                                        :class="['select-option', {'is-selected' : item.id === seasonsData.find(item => item.active).id}]"
                                        @click="seasonsData = seasonsData.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                        ><span class="select-option__name"><b>{{item.name}}</b> <i>{{item.dateFrom}} - {{item.dateTo}}</i></span></div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <button type="submit" class="btn btn--green edit-popup__submit" @click="copyParkSeasonsFromPark">
                            <svg width="1em" height="1em" class="icon icon-copy ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                            </svg><span>Copy</span>
                        </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

    import Seasons from './Seasons'
    import SeasonBox from './SeasonBox'

    import { getSeasonsType, getParks, createParkPrice, getParkPrice, copyParkSeasons, copyParkSeasonsSeason } from '@/utilites/api'

    export default {
        data(){
            return {
                isOpenSeasons: false,
                seasons: [],
                seasonsData: [],
                parks: [],
                selects: {
                    seasons: false,
                    seasonsData: false,
                    park: false
                },
                crater: true,
                copySeason: false,
                copySeasonPark: false,
                data: {
                    driverFree: '',
                    driverFreeCur: 'USD',
                    kg2001: '',
                    kg2001Cur: 'USD',
                    craterFor: '',
                    craterForCur: 'USD',
                    craterEast: '',
                    craterEastCur: 'USD',
                    adultSA: '',
                    adultSACur: 'USD',
                    teenSA: '',
                    teenSACur: 'USD',
                    childSA: '',
                    childSACur: 'USD',
                    adultFor: '',
                    adultForCur: 'USD',
                    teenFor: '',
                    teenForCur: 'USD',
                    childFor: '',
                    childForCur: 'USD',
                    adultExp: '',
                    adultExpCur: 'USD',
                    teenExp: '',
                    teenExpCur: 'USD',
                    childExp: '',
                    childExpCur: 'USD'
                }
            }
        },
        props: ['user', 'park', 'save'],
        components: { Seasons, SeasonBox },
        methods: {
            changeSelects(target){
				this.selects = {
                    seasons: false,
                    seasonsData: false,
                    park: false,
                    [target] : !this.selects[target]
				}
                this.$emit('closeSelects')
			},
            closeSeasons(){
                this.isOpenSeasons = false
            },
            updateData(){
                getSeasonsType(this.user.access_token, 'park')
                .then(res => {
                    this.seasons = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
                    this.seasonsData = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
                    if(this.park){
                        getParkPrice(this.user.access_token, this.seasons.find(item => item.active).id, this.park.id)
                        .then(res => {
                            this.data = {
                                driverFree: res.prices.carDriverFees.driverFee.price,
                                driverFreeCur: res.prices.carDriverFees.driverFee.currency,
                                kg2001: res.prices.carDriverFees.from2001To3000kg.price,
                                kg2001Cur: res.prices.carDriverFees.from2001To3000kg.currency,
                                craterFor: res.prices.craterFees ? res.prices.craterFees.feesForeign.price : 0,
                                craterForCur: res.prices.craterFees ? res.prices.craterFees.feesForeign.currency : 'USD',
                                craterEast: res.prices.craterFees ? res.prices.craterFees.feesEA.price : 0,
                                craterEastCur: res.prices.craterFees ? res.prices.craterFees.feesEA.currency : 'USD',

                                adultSA: res.prices.parkFeesEA.adult.price,
                                adultSACur: res.prices.parkFeesEA.adult.currency,
                                teenSA: res.prices.parkFeesEA.teenager.price,
                                teenSACur: res.prices.parkFeesEA.teenager.currency,
                                childSA: res.prices.parkFeesEA.child.price,
                                childSACur: res.prices.parkFeesEA.child.currency,

                                adultFor: res.prices.parkFeesForeign.adult.price,
                                adultForCur: res.prices.parkFeesForeign.adult.currency,
                                teenFor: res.prices.parkFeesForeign.teenager.price,
                                teenForCur: res.prices.parkFeesForeign.teenager.currency,
                                childFor: res.prices.parkFeesForeign.child.price,
                                childForCur: res.prices.parkFeesForeign.child.currency,

                                adultExp: res.prices.parkFeesExpat.adult.price,
                                adultExpCur: res.prices.parkFeesExpat.adult.currency,
                                teenExp: res.prices.parkFeesExpat.teenager.price,
                                teenExpCur: res.prices.parkFeesExpat.teenager.currency,
                                childExp: res.prices.parkFeesExpat.child.price,
                                childExpCur: res.prices.parkFeesExpat.child.currency
                            }
                        })
                    }
                })
            },
            changeCurrency(data){
                this.data[data.name + 'Cur'] = data.value
            },
            changeValue(data){
                this.data[data.name] = data.value
            },
            changeCurrencyCamping(data){
                this.data.camping[data.index][data.name + 'Cur'] = data.value
            },
            changeValueCamping(data){
                this.data.camping[data.index][data] = data.value
            },
            createParkPricesHandler(){
                createParkPrice(this.user.access_token, this.seasons.find(item => item.active).id, this.park.id, {
                    "carDriverFees": {
                        "from2001To3000kg": {
                            "currency": this.data.kg2001Cur,
                            "price": +this.data.kg2001
                        },
                        "driverFee": {
                            "currency": this.data.driverFreeCur,
                            "price": +this.data.driverFree
                        }
                    },
                    "parkFeesEA": {
                        "child": {
                            "currency": this.data.childSACur,
                            "price": +this.data.childSA
                        },
                        "teenager": {
                            "currency": this.data.teenSACur,
                            "price": +this.data.teenSA
                        },
                        "adult": {
                            "currency": this.data.adultSACur,
                            "price": +this.data.adultSA
                        }
                    },
                    "parkFeesForeign": {
                        "child": {
                            "currency": this.data.childForCur,
                            "price": +this.data.childFor
                        },
                        "teenager": {
                            "currency": this.data.teenForCur,
                            "price": +this.data.teenFor
                        },
                        "adult": {
                            "currency": this.data.adultForCur,
                            "price": +this.data.adultFor
                        }
                    },
                    "parkFeesExpat": {
                        "child": {
                            "currency": this.data.childExpCur,
                            "price": +this.data.childExp
                        },
                        "teenager": {
                            "currency": this.data.teenExpCur,
                            "price": +this.data.teenExp
                        },
                        "adult": {
                            "currency": this.data.adultExpCur,
                            "price": +this.data.adultExp
                        }
                    },
                    "craterFees": {
                        "feesForeign": {
                            "currency": this.data.craterForCur,
                            "price": +this.data.craterFor
                        },
                        "feesEA": {
                            "currency": this.data.craterEastCur,
                            "price": this.data.craterEast
                        },
                        "feesResidence": {
                            "currency": "USD",
                            "price": 0
                        }
                    }
                })
                .then(res => {
                    this.$router.push('/safari/parks')
                })
            },
            copyParkSeasonsFromPark(){
                copyParkSeasons(this.seasonsData.find(item => item.active).id, this.seasons.find(item => item.active).id, this.parks.find(item => item.active).id,this.park.id)
                .then(res => {
                    this.data = {
                        driverFree: res.prices.carDriverFees.driverFee.price,
                        driverFreeCur: res.prices.carDriverFees.driverFee.currency,
                        kg2001: res.prices.carDriverFees.from2001To3000kg.price,
                        kg2001Cur: res.prices.carDriverFees.from2001To3000kg.currency,
                        craterFor: res.prices.craterFees.feesForeign.price,
                        craterForCur: res.prices.craterFees.feesForeign.currency,
                        craterEast: res.prices.craterFees.feesEA.price,
                        craterEastCur: res.prices.craterFees.feesEA.currency,
                        adultSA: res.prices.parkFeesEA.adult.price,
                        adultSACur: res.prices.parkFeesEA.adult.currency,
                        teenSA: res.prices.parkFeesEA.teenager.price,
                        teenSACur: res.prices.parkFeesEA.teenager.currency,
                        childSA: res.prices.parkFeesEA.child.price,
                        childSACur: res.prices.parkFeesEA.child.currency,

                        adultFor: res.prices.parkFeesForeign.adult.price,
                        adultForCur: res.prices.parkFeesForeign.adult.currency,
                        teenFor: res.prices.parkFeesForeign.teenager.price,
                        teenForCur: res.prices.parkFeesForeign.teenager.currency,
                        childFor: res.prices.parkFeesForeign.child.price,
                        childForCur: res.prices.parkFeesForeign.child.currency,

                        adultExp: res.prices.parkFeesExpat.adult.price,
                        adultExpCur: res.prices.parkFeesExpat.adult.currency,
                        teenExp: res.prices.parkFeesExpat.teenager.price,
                        teenExpCur: res.prices.parkFeesExpat.teenager.currency,
                        childExp: res.prices.parkFeesExpat.child.price,
                        childExpCur: res.prices.parkFeesExpat.child.currency
                    }
                    this.copySeasonPark = false
                })
                .catch(() => {
                    this.$emit('errored')
                    this.copySeasonPark = false
                })
            },
             copyParkSeasonsFromSeason(){
                copyParkSeasons(this.seasonsData.find(item => item.active).id, this.seasons.find(item => item.active).id, this.park.id, this.park.id)
                .then(res => {
                    this.data = {
                        driverFree: res.prices.carDriverFees.driverFee.price,
                        driverFreeCur: res.prices.carDriverFees.driverFee.currency,
                        kg2001: res.prices.carDriverFees.from2001To3000kg.price,
                        kg2001Cur: res.prices.carDriverFees.from2001To3000kg.currency,
                        craterFor: res.prices.craterFees.feesForeign.price,
                        craterForCur: res.prices.craterFees.feesForeign.currency,
                        craterEast: res.prices.craterFees.feesEA.price,
                        craterEastCur: res.prices.craterFees.feesEA.currency,
                        adultSA: res.prices.parkFeesEA.adult.price,
                        adultSACur: res.prices.parkFeesEA.adult.currency,
                        teenSA: res.prices.parkFeesEA.teenager.price,
                        teenSACur: res.prices.parkFeesEA.teenager.currency,
                        childSA: res.prices.parkFeesEA.child.price,
                        childSACur: res.prices.parkFeesEA.child.currency,

                        adultFor: res.prices.parkFeesForeign.adult.price,
                        adultForCur: res.prices.parkFeesForeign.adult.currency,
                        teenFor: res.prices.parkFeesForeign.teenager.price,
                        teenForCur: res.prices.parkFeesForeign.teenager.currency,
                        childFor: res.prices.parkFeesForeign.child.price,
                        childForCur: res.prices.parkFeesForeign.child.currency,

                        adultExp: res.prices.parkFeesExpat.adult.price,
                        adultExpCur: res.prices.parkFeesExpat.adult.currency,
                        teenExp: res.prices.parkFeesExpat.teenager.price,
                        teenExpCur: res.prices.parkFeesExpat.teenager.currency,
                        childExp: res.prices.parkFeesExpat.child.price,
                        childExpCur: res.prices.parkFeesExpat.child.currency
                    }
                    this.copySeason = false
                })
                .catch(() => {
                    this.$emit('errored')
                    this.copySeason = false
                })
            }
        },
        mounted(){
            this.updateData()
            getParks(this.user.access_token)
            .then(res => {
                this.parks = res.map((item, index) => index === 0 ? {...item, active: true} :({...item, active: false}))
            })
             window.addEventListener('click', event => {
                if(!event.target.closest('.edit-popup') && !event.target.closest('.btn')){
                    this.copySeason = false
                    this.copySeasonPark = false
                }
                if(!event.target.closest('.select-wrapper')){
                    this.selects = {
                        seasons: false,
                        seasonsData: false,
                        park: false
                    }
                }
            })
            const onClickOutside = e => {
                this.selects = {
                    seasons:  this.$el.contains(e.target) && this.selects.seasons,
                    seasonsData:  this.$el.contains(e.target) && this.selects.seasonsData,
                    park:  this.$el.contains(e.target) && this.selects.park
                }
            };
            document.addEventListener('click', onClickOutside);
            this.$on('hook:beforeDestroy', () => document.removeEventListener('click', onClickOutside));
        },
        watch: {
            seasons(){
                if(this.park){
                    getParkPrice(this.user.access_token, this.seasons.find(item => item.active).id, this.park.id)
                    .then(res => {
                        this.data = {
                            driverFree: res.prices.carDriverFees.driverFee.price,
                            driverFreeCur: res.prices.carDriverFees.driverFee.currency,
                            kg2001: res.prices.carDriverFees.from2001To3000kg.price,
                            kg2001Cur: res.prices.carDriverFees.from2001To3000kg.currency,
                            craterFor: res.prices.craterFees.feesForeign.price,
                            craterForCur: res.prices.craterFees.feesForeign.currency,
                            craterEast: res.prices.craterFees.feesEA.price,
                            craterEastCur: res.prices.craterFees.feesEA.currency,
                            adultSA: res.prices.parkFeesEA.adult.price,
                            adultSACur: res.prices.parkFeesEA.adult.currency,
                            teenSA: res.prices.parkFeesEA.teenager.price,
                            teenSACur: res.prices.parkFeesEA.teenager.currency,
                            childSA: res.prices.parkFeesEA.child.price,
                            childSACur: res.prices.parkFeesEA.child.currency,

                            adultFor: res.prices.parkFeesForeign.adult.price,
                            adultForCur: res.prices.parkFeesForeign.adult.currency,
                            teenFor: res.prices.parkFeesForeign.teenager.price,
                            teenForCur: res.prices.parkFeesForeign.teenager.currency,
                            childFor: res.prices.parkFeesForeign.child.price,
                            childForCur: res.prices.parkFeesForeign.child.currency,

                            adultExp: res.prices.parkFeesExpat.adult.price,
                            adultExpCur: res.prices.parkFeesExpat.adult.currency,
                            teenExp: res.prices.parkFeesExpat.teenager.price,
                            teenExpCur: res.prices.parkFeesExpat.teenager.currency,
                            childExp: res.prices.parkFeesExpat.child.price,
                            childExpCur: res.prices.parkFeesExpat.child.currency
                        }
                    })
                    .catch(() => {
                        this.data = {
                                driverFree: '',
                                driverFreeCur:'USD',
                                kg2001: '',
                                kg2001Cur: 'USD',
                                craterFor: '',
                                craterForCur: 'USD',
                                craterEast: '',
                                craterEastCur: 'USD',
                                adultSA: '',
                                adultSACur: 'USD',
                                teenSA: '',
                                teenSACur: 'USD',
                                childSA: '',
                                childSACur: 'USD',

                                adultFor: '',
                                adultForCur: 'USD',
                                teenFor: '',
                                teenForCur: 'USD',
                                childFor:'',
                                childForCur: 'USD',

                                adultExp:'',
                                adultExpCur: 'USD',
                                teenExp: '',
                                teenExpCur: 'USD',
                                childExp: '',
                                childExpCur: 'USD'
                            }
                    })
                }
            },
            save(){
                this.createParkPricesHandler()
            },
            park(){
                this.updateData()
            },
            isOpenSeasons(){
                this.updateData()
            },
        }
    }
</script>
